export enum CouposApiMethods {
    getCoupons = 'Coupons.GetCoupons',
    createCoupon = 'Coupons.CreateCoupon',
    deleteCoupon = 'Coupons.DeleteCoupon',
    updateCoupon = 'Coupons.UpdateCoupon',
}
